import { Box, ScaleFade, Slide, Stack, Text } from "@chakra-ui/react";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import axios from "axios";
import tinycolor from "tinycolor2";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSessionId } from "../client/sessionSetup";
import {
  checkLoginUserid,
  createOrConnectRoom,
  getUserChat,
  sendDataToConnectedUser,
  sendKafkaEvent,
} from "../client/wss";
import appstore from "../store/appStore";
import { ChatMenu } from "./components/ChatMenu";
import { HomeMenu } from "./components/HomeMenu";
import { PoweredBy } from "./components/PoweredBy";
import { motion } from "framer-motion";
import { ProductContext } from "./components/ProductContext";

const transformData = (data) => {
  const result = [];
  let tempGroup = [];

  data.forEach((item) => {
    if (item.text && item.text.props && "ele" in item.text.props) {
      tempGroup.push(item);
    } else {
      if (tempGroup.length > 0) {
        result.push(tempGroup);
        tempGroup = [];
      }
      result.push(item);
    }
  });

  if (tempGroup.length > 0) {
    result.push(tempGroup);
  }

  return result;
};

export default function Home({ botid }) {
  const {
    messages,
    setMessages,
    setBotDetails,
    botDetails,
    suggestions,
    showTyping,
    getShopifyCart,
    getBigcommerceCart,
    setSuggestions,
    setMessagesToNewChat,
    mycart,
    addCreateCartUlai,
    updateShopifyCart,
    cartId,
    origin,

  } = appstore();
  const MotionDiv = motion.div;
  const getRandomIntExclusive = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  };
  const [transformedData, setTransformedData] = useState([]);

  const [showButtonLoader, setShowButtonLoader] = useState(false);
  const [isloading, setLoading] = useState(false);
  const [isConvoHide, setIsConvoHide] = useState(false);
  const [triviaDetails, setTriviaDetails] = useState({
    isActive: false,
    trivia: {
      trivia:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore neque laboriosam cumque, consequuntur laborum voluptatibus recusandae exercitationem incidunt fugit fugiat vitae laudantium quia eos assumenda atque consectetur debitis earum dolores!",
      butttons: [{ text: "Know more" }, { text: "Thanks" }],
    },
  });

  const [initialCallMade, setInitialCallMade] = useState(false);
  const [clickedKnowMoreAboutit, setClickedKnowMoreAboutit] = useState({
    text: "",
    isClicked: false,
  });
  const [storeAllSuggestion, storeAllSuggestions] = useState(null);
  const [contactUsMsgSend, setIsContactUsMsgSend] = useState({
    isSend: false,
    inputDetails: { fullName: "", email: "", msg: "" },
  });
  const [conversationStart, setIsConversationStart] = useState({
    isStart: false,
    inputDetails: { email: "", phone: "" },
  });
  const [trackOrderSearched, setTrackOrderSearched] = useState({
    isSearched: false,
    notFound: false,
    detail: { status: "", orderNo: "", trackLink: "", subTotal: "" },
    inputDetails: { orderNo: "", phoneOrEmail: "" },
  });

  const [botOpen, setBotOpen] = useState(false);
  const [currentChatPanelview, setCurrentChatPanelview] = useState("Home");
  const [floatOpen, setFloatOpen] = useState(() => {
    const storedFloatOpen = localStorage.getItem("floatOpen");

    return storedFloatOpen ? storedFloatOpen === "true" : true;
  });
  let currentTime = "";
  const messagesContainerRef = useRef(null);
  const [userMessage, setUserMessage] = useState("");
  const [rufusQue, setRufusQues] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [isAskingRating, setAskingRating] = useState(false);
  const [showEndConv, setShowEndConv] = useState(false);
  const [rating, setRating] = useState(0);
  const [error, setError] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [scrolled, setScrolled] = useState(0);
  const [hideBot, setHideBot] = useState(false);
  const [draggableBoxHeight, setDraggableBoxHeight] = useState(0);
  const [rufusSend,setRufusSend]=useState({})
  const [mobileRufsData,setMobileRufsData]=useState({})
  const [isAskii,setIsAskii]=useState(false)
  const [productId,setProductId]=useState(null)
  const { selectedVarient, setSelectedvarient,isExist,setIsExist,getData,setGetData } = useContext(ProductContext);
  const onEmojiClick = (emojiObject, event) => {
    if (emojiObject && emojiObject.emoji) {
      setUserMessage((prevInput) => prevInput + emojiObject.emoji);
    }

    setShowPicker(false);
  };

  const openCart = async () => {
    if (botDetails.storeName === "Shopify") {
      window.parent.postMessage({ type: "ShopifyCall",shopifyCall:true }, "*");
    }
    setCurrentChatPanelview("mycart");
  };
  const handleQty = async (qty, varientId, productId, itemId) => {
  
    if (botDetails.storeName === "Shopify") {
      let item = {
        id: `${varientId}`,
        quantity: qty,
      };

      setLoading(true);
    
      window.parent.postMessage({ type: "shopifyHandleQty", qty, varientId, productId, itemId }, "*");
     
         
    
    } else if (botDetails.storeName === "Bigcommerce") {
      const options = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: `{"lineItem":{"quantity":${qty},"productId":${productId},"variantId":${varientId}}}`,
      };
      window.parent.postMessage({ type: "shopifyHandleQty", qty, varientId, productId, itemId }, "*");
      // console.log("localStorage", localStorage.getItem("cartId"));
      // setLoading(true);
      // const response = await fetch(
      //   `/api/storefront/carts/${localStorage.getItem(
      //     "cartId"
      //   )}/items/${itemId}?include=lineItems.physicalItems.options`,
      //   options
      // )
      //   .then((response) => response.json())
      //   .catch((err) => console.error(err));

      // if (response) {
      //   let tempList = [];
      //   let productArray = [];
      //   response.lineItems?.physicalItems?.forEach((element) => {
      //     tempList.push(element?.productId);
      //     productArray.push({
      //       productId: element?.productId,
      //       quantity: element?.quantity,
      //       varient: [{ varientId: element?.variantId }],
      //     });
      //   });
      //   let totalPrice = response?.cartAmount;
      //   let subTotal = response?.baseAmount?.toString();

      //   let cart = await getBigcommerceCart();
      //   addCreateCartUlai(
      //     response?.id,
      //     botDetails?.userId,
      //     productArray,
      //     totalPrice,
      //     subTotal
      //   );
      // }
      setLoading(false);
    }
  };
  const isColorDark = (color) => {
    const colorObj = tinycolor(color);
    return colorObj.isDark();
  };


  useEffect(() => {
    localStorage.setItem("floatOpen", floatOpen);
  }, [floatOpen]);
  const sendMessageToBot = async (event, rufusText = "") => {
    // console.log("calling..........")
    const currentTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    if (event) {
      event.preventDefault();
    }

    // console.log("botDetails", botDetails,getSessionId());
   
    const sendData = JSON.stringify({
      identity: "USER",
      message: rufusText.length > 0 ? rufusText : userMessage,
      roomId: getSessionId(),
      organization_id: botDetails.userId,
      type: botDetails.botType,
      time: "",
      bot_id: botDetails._id,
      domain:origin,
      companyName: botDetails.companyName,
      uid: botDetails.sqlId,
      unqiueBrowserId: await getCurrentBrowserFingerPrint(),
      isAskiMessage:isAskii,
      productId:productId?productId:""
      // company_name: us,
    });
    // console.log ("sendDAtdirea",sendData);
    if (userMessage.length > 0 || rufusText.length > 0) {
    
      setMobileRufsData({sendData,messages: rufusText.length > 0 ? rufusText : userMessage,currentTime})
      sendDataToConnectedUser(sendData);
      setMessages(
        rufusText.length > 0 ? rufusText : userMessage,
        true,
        currentTime
      );
      setUserMessage("");
      setRufusSend({})
    }
  };


  const openChatBotFromTrivia = () => {
    const websdkOpen = localStorage.getItem("ul-websdk_bot_open") || false;
    if (botOpen == false && websdkOpen == false) {
      localStorage.setItem("ul-websdk_bot_open", true);
      sendKafkaEvent({
        eventName: "websdk_bot_open",
        userId: botDetails.userId,
        chatId: getSessionId(localStorage.getItem("sessionUUID")),
      });
    }
    setBotOpen(true);
    // appstore.getState().setShowSuggestions(true);
    setFloatOpen(false);
  };

  const sendMessageToBotDirectly = async (msg) => {
    openChatBotFromTrivia();
    setIsConversationStart({ ...conversationStart, isStart: true });
    await setCurrentChatPanelview("conversation");
    appstore.getState().setShowSuggestions(false);
    const currentTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const sendData = JSON.stringify({
      identity: "USER",
      message: msg,
      roomId: getSessionId(localStorage.getItem("sessionUUID")),
      organization_id: botDetails.userId,
      type: botDetails.botType,
      time: "",
      bot_id: botDetails._id,
      domain: origin,
      companyName: botDetails.companyName,
      uid: botDetails.sqlId,
      unqiueBrowserId: await getCurrentBrowserFingerPrint(),
      isAskiMessage:isAskii,
      productId:productId?productId:""
    });
    console.log ("sendDAta",sendData);
    if (msg.length > 0) {
      sendDataToConnectedUser(sendData);
      setMessages(msg, true, currentTime);
      setUserMessage("");
    }
    setClickedKnowMoreAboutit({
      ...clickedKnowMoreAboutit,
      isClicked: false,
    });
  };

  const openChatBot = () => {
    const websdkOpen = localStorage.getItem("ul-websdk_bot_open") || false;
    if (botOpen == false && websdkOpen == false) {
      localStorage.setItem("ul-websdk_bot_open", true);
      sendKafkaEvent({
        eventName: "websdk_bot_open",
        userId: botDetails.userId,
        chatId: getSessionId(localStorage.getItem("sessionUUID")),
      });
    }
    setBotOpen((prev) => !prev);
    appstore.getState().setShowSuggestions(true);

    setFloatOpen((prev) => !prev);
  };

  //   event.stopPropagation();
  //   setFloatOpen((prev) => false);
  // };

  const onSuggestionSelected = async (data) => {
    appstore.getState().setShowSuggestions(false);

    const currentTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const sendData = JSON.stringify({
      identity: "USER",
      message: data,
      roomId: getSessionId(localStorage.getItem("sessionUUID")),
      organization_id: botDetails.userId,
      type: botDetails.botType,
      time: "",
      bot_id: botDetails._id,
      domain: origin,
      uid: "tbJLwRYgT2aBODyMdtn6YS9BZxszuAYi",
      socket_id: "",
      unqiueBrowserId: await getCurrentBrowserFingerPrint(),
    });
    // console.log("sendMessageToBot", sendData);
    sendDataToConnectedUser(sendData);
    setMessages(data, true, currentTime);

    setUserMessage("");
  };

  useEffect(() => {
    window.parent.postMessage({ type: "botLoad", botLoad:true }, "*");
    (async () => {
      try {
        axios(
          `${process.env.REACT_APP_API_BASE_URL}/bot/${botid}`,
          // "http://localhost:3001/bot/652150accd05a75edb9de2bf",
          {
            method: "GET",
          }
        )
          .then(async function (resp) {
            if (resp.data) {
              createOrConnectRoom();
              window.parent.postMessage({ type: "botLoad", botLoad:false }, "*");
              storeAllSuggestions(resp.data.initialChatsuggestions);
              setSuggestions(resp.data.initialChatsuggestions);
              
              getUserChat(getSessionId(localStorage.getItem("sessionUUID")));
              if (resp.data.storeName === "Bigcommerce") {
                window.parent.postMessage({ type: "bigComCall",bigComCall:true }, "*");
              
              } else if (resp.data.storeName === "Shopify") {
                window.parent.postMessage({ type: "ShopifyCall",shopifyCall:true }, "*");
                // await getShopifyCart();
              }
              let flag = false;
              if (resp?.data?.menuSection?.conversation == false) {
                setIsConvoHide(true);
                if (resp?.data?.menuSection?.trackOrder) {
                  setCurrentChatPanelview("trackOrder");
                } else if (resp?.data?.menuSection?.contactUs) {
                  setCurrentChatPanelview("contactUs");
                } else {
                  flag = true;
                }
              }
              if (!flag) {
                if (resp.data?.whatsappRedirectLink) {
                  setBotDetails(resp.data);
                } else {
                  setBotDetails({
                    ...resp.data,
                    menuSection: { ...resp.data.menuSection, whatsapp: false },
                  });
                }
                setInitialCallMade(true);
              }
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } catch (error) {
        console.log("error", error);
      }
    })();
  }, [botid]);

async function knowMoreAboutIt(text) {
    
    if (
      botDetails.askDetailsBeforeChat &&
      !conversationStart.isStart &&
      (botDetails.askEmail || botDetails.askPhone)
    ) {
      setClickedKnowMoreAboutit({
        text: text,
        isClicked: true,
      });
      setTriviaDetails({ ...triviaDetails, isActive: false });
      window.parent.postMessage({type:"botOpen",botOpen:true})
    } else {
      
      setTriviaDetails({ ...triviaDetails, isActive: false });
      sendMessageToBotDirectly(text);
    }
  }

  useEffect(() => {
    const transformedData = transformData(messages);
    setTransformedData(transformedData);
  }, [messages]);

  useEffect(() => {
   
    if (
      botOpen &&
      conversationStart.isStart &&
      currentChatPanelview == "conversation"
    ) {
      // if (!messages[messages.length - 1]?.text?.props) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
      // }
    }
    if (messages.length != 0) {
      setShowEndConv(false);
      setIsConversationStart({ ...conversationStart, isStart: true });
      if (currentChatPanelview == "Home") {
        setCurrentChatPanelview("conversation");
      }
      // handleDebounce();
    }
    if (messagesContainerRef.current) {
    
      const { scrollTop, scrollHeight, clientHeight } =
        messagesContainerRef.current;
      setScrolled(scrollTop);
    }
  }, [messages, botOpen, currentChatPanelview, transformedData, suggestions]);
  const handleSubmitReview = () => {
    sendKafkaEvent({
      eventName: "websdk_chat_review",
      userId: botDetails.userId,
      rating: rating,
      chatId: getSessionId(localStorage.getItem("sessionUUID")),
    });
    setIsConversationStart({
      isStart: true,
      inputDetails: { email: "", phone: "" },
    });
    setAskingRating(false);
    setShowEndConv(false);
    getSessionId();
    openChatBot();
    setMessagesToNewChat();
    setRating(0);
    setSuggestions(storeAllSuggestion);
    createOrConnectRoom();
    setCurrentChatPanelview("Home");
    setFloatOpen(true);
  };
  const MAX_ATTEMPTS = 20;
  useEffect(() => {
    let attempts = 0;

    if (botDetails?.userId) {
      const checkCid = () => {
        if (window?.__st?.cid) {
          checkLoginUserid(
            botDetails?.userId,
            getSessionId(localStorage.getItem("sessionUUID"))
          );
        } else if (attempts < MAX_ATTEMPTS) {
          attempts++;
          setTimeout(checkCid, 500); // Poll every 100ms
        } else {
          // Stop polling and show an error if it never loads
        }
      };

      checkCid();
    } // Initial check

    // Check if the device is mobile
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500); // Adjust the threshold as needed
    };

    handleResize(); // Check initially
    window.addEventListener("resize", handleResize); // Listen for window resize events

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup event listener
    };
  }, [botDetails?.userId]);
  const handleTrackOrder = async (e) => {
    e.preventDefault();
    let data = JSON.stringify({
      storeOrderId: `%23${trackOrderSearched.inputDetails.orderNo}`,
      phoneOrEmail: trackOrderSearched.inputDetails.phoneOrEmail,
      userId: botDetails.userId,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/order/getEcomOrder`,
      headers: {
        xAuthKey:
          "57f78d0a63d6e6b1c41c3d05848645a6c0d446d23f9c1d732b61ce3a78459418",
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      setLoading(true);
      const respData = await axios.request(config);
      // console.log("data", respData.data);
      if (respData.data.success) {
        setTrackOrderSearched({
          isSearched: true,
          notFound: false,
          detail: {
            status: respData.data.orderStatus,
            orderNo: respData.data.storeOrderId,
            trackLink: respData.data.orderStatusUrl,
            subTotal: respData.data.subtotal,
          },
        });
      } else {
        setTrackOrderSearched({
          ...trackOrderSearched,
          isSearched: true,
          notFound: true,
        });
      }
      setLoading(false);
    } catch (error) {
      // console.log("data", error);
      setTrackOrderSearched({
        ...trackOrderSearched,
        isSearched: true,
        notFound: true,
      });
      setLoading(false);
    }
  };
  const handleStartConversation = async (e) => {
    e.preventDefault();
    if(botDetails.askPhone&&conversationStart.inputDetails.phone.length> 10||botDetails.askPhone&&conversationStart.inputDetails.phone.length
      <10){
     setError(true)
    }
   else if (
      botDetails.askEmail ||
      conversationStart.inputDetails.phone.length == 10
    ) {
      setError(false);

      let data = JSON.stringify({
        userId: botDetails.userId,
        sessonId: getSessionId(localStorage.getItem("sessionUUID")),
        unqiueBrowserId:await getCurrentBrowserFingerPrint(),
        phone: botDetails.askPhone
          ? conversationStart.inputDetails.phone
          : null,
        email: botDetails.askEmail
          ? conversationStart.inputDetails.email
          : null,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_BASE_URL}/customerInformation/add`,
        headers: {
          xAuthKey:
            "57f78d0a63d6e6b1c41c3d05848645a6c0d446d23f9c1d732b61ce3a78459418",
          "Content-Type": "application/json",
        },
        data: data,
      };
      try {
        setLoading(true);
        const respData = await axios.request(config);
        // console.log("data", respData.data);
        setIsConversationStart({ ...conversationStart, isStart: true });
        localStorage.setItem("isConStart", true);
        setCurrentChatPanelview("conversation");
        if (clickedKnowMoreAboutit.isClicked) {
          sendMessageToBotDirectly(clickedKnowMoreAboutit.text);
        }
        setLoading(false);
      } catch (error) {
        // console.log("data", error);
        setLoading(false);
      }
    } else if (conversationStart.inputDetails.phone.length != 10) {
      // console.log(conversationStart.inputDetails.phone.length);
      setError(true);
    }
  };
  const handleContactUs = async (e) => {
    e.preventDefault();
    let data = JSON.stringify({
      userId: botDetails.userId,
      sessonId: getSessionId(localStorage.getItem("sessionUUID")),
      fullName: contactUsMsgSend.inputDetails.fullName,
      email: contactUsMsgSend.inputDetails.email,
      msg: contactUsMsgSend.inputDetails.msg,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_BASE_URL}/contactus/add`,
      headers: {
        xAuthKey:
          "57f78d0a63d6e6b1c41c3d05848645a6c0d446d23f9c1d732b61ce3a78459418",
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      setLoading(true);
      const respData = await axios.request(config);
      // console.log("data", respData.data);
      setLoading(false);
      setIsContactUsMsgSend({ ...contactUsMsgSend, isSend: true });
    } catch (error) {
      // console.log("data", error);
      setLoading(false);
    }
  };


  useEffect(() => {
    const preventBodyScrollOnElementScroll = (e) => {
      // Check if the scroll is happening on an element with one of the target classes
      const scrollableContainers = document.querySelectorAll(
        ".chat-bot-text-display-container, .chatbotSendInput, .chatbotHeaderMenu, .ui-poweredby-strip,.homemenu"
      );

      let isScrollInsideTarget = false;

      // Check if the event target is inside any of the scrollable containers
      scrollableContainers.forEach((container) => {
        if (container.contains(e.target)) {
          isScrollInsideTarget = true;
        }
      });

      // Prevent body scroll if the event occurred inside the target containers
      if (isScrollInsideTarget) {
        document.body.style.overflow = "hidden"; // Prevent body scroll
      } else {
        document.body.style.overflow = "auto"; // Enable body scroll
      }
    };

    const resetBodyScroll = () => {
      document.body.style.overflow = "auto"; // Reset body scroll
    };

    if (botOpen) {
      // Add event listeners for scroll and touch events
      window.addEventListener("wheel", preventBodyScrollOnElementScroll, {
        passive: false,
      });
      window.addEventListener("touchmove", preventBodyScrollOnElementScroll, {
        passive: false,
      });

      // Add event listener for mouse leave or touch end to reset body overflow
      const scrollableContainers = document.querySelectorAll(
        ".chat-bot-text-display-container,.chatbotSendInput,.chatbotHeaderMenu,.ui-poweredby-strip,.homemenu"
      );
      scrollableContainers.forEach((container) => {
        container.addEventListener("mouseleave", resetBodyScroll);
        container.addEventListener("touchend", resetBodyScroll);
      });
    } else {
      // Remove event listeners when bot is closed
      window.removeEventListener("wheel", preventBodyScrollOnElementScroll);
      window.removeEventListener("touchmove", preventBodyScrollOnElementScroll);

      const scrollableContainers = document.querySelectorAll(
        ".chat-bot-text-display-container,.chatbotSendInput,.chatbotHeaderMenu,.ui-poweredby-strip,.homemenu"
      );
      scrollableContainers.forEach((container) => {
        container.removeEventListener("mouseleave", resetBodyScroll);
        container.removeEventListener("touchend", resetBodyScroll);
      });

      document.body.style.overflow = "auto"; // Reset body scroll
    }

    // Cleanup function to remove event listeners
    return () => {
      window.removeEventListener("wheel", preventBodyScrollOnElementScroll);
      window.removeEventListener("touchmove", preventBodyScrollOnElementScroll);

      const scrollableContainers = document.querySelectorAll(
        ".chat-bot-text-display-container,.chatbotSendInput,.chatbotHeaderMenu,.ui-poweredby-strip,.homemenu"
      );
      scrollableContainers.forEach((container) => {
        container.removeEventListener("mouseleave", resetBodyScroll);
        container.removeEventListener("touchend", resetBodyScroll);
      });

      document.body.style.overflow = "auto"; // Ensure body scroll is reset
    };
  }, [botOpen]);
  const [displayTriviaComponent, setDisplayTriviaComponent] = useState(false); //set your preferences here
  useEffect(() => {
    var isConStart = localStorage.getItem("isConStart") || false;
    if (isConStart && botOpen) {
      const event = { preventDefault: () => {} };
      setIsConversationStart({ ...conversationStart, isStart: true });
      setCurrentChatPanelview("conversation");
    }

    if (triviaDetails.isActive && triviaDetails.timer) {
      setTimeout(() => {
        // console.log("triviaDetails.timer", triviaDetails.timer);
        setDisplayTriviaComponent(true);
      }, [triviaDetails.timer]);
    }
    if (isMobile) {
      const delay = setTimeout(() => {
        setHideBot(true);
        // console.log(hideBot);
        clearTimeout(delay);
      }, 1000);
      if (hideBot) {
        let height = 10;

        const transition = setInterval(() => {
          setDraggableBoxHeight((prev) => {
            if (prev >= 75) {
              clearInterval(transition);
              return 75;
            }
            return prev + 5;
          });
        }, 50);
      }
    }
  }, [botOpen, triviaDetails, hideBot]);
  // Only depend on botOpen for toggling
  useEffect(() => {

    const handleMessage = (event) => {
      if (event.data.type === "rufusText") {
        setIsAskii(event.data.askii)
        setProductId(event.data.productId)
        setRufusSend({type:event.data.type,message:event.data.rufusText})
      }
      else if(event.data.type=="rufusTextKnow"){
           setProductId(event.data.productId)
        setIsAskii(event.data.askii)
        setRufusSend({type:event.data.type,message:event.data.rufusText})
      }
      else if(event.data.type=="askii"){
        
        setIsAskii(event.data.askii)
      }
      else if(event.data.type=="botOpen"){
        setBotOpen(event.data.botOpen)
      }
      else if(event.data.type=="shopifyCartData"){
        
        getShopifyCart(event.data.shopifyCartData)
        setLoading(false);
      }
      else if(event.data.type=="bigComCartData"){
        // console.log(event.data.bigComCartData,"==========>cartData is coming")
        getBigcommerceCart(event.data.bigComCartData)
        setLoading(false);
      }
      else if(event.data.type=="shopifyFlowData"){
        setGetData(event.data.shopifyFlowData)
    
      }
      else if(event.data.type=="bigComFlowData"){
        // console.log(event.data.bigComFlowData,"======+>Dfdfdf")
        setGetData(event.data.bigComFlowData)
        setLoading(false);
    
      }
     
    else if(event.data.type==="shopifyCartUpdate"){

      const cart=event.data.shopifyCartData
      updateShopifyCart(cart);
      let productArray = [];
      cart.items.forEach((element) => {
        productArray.push({
          productId: element.product_id,
          quantity: element.quantity,
          varient: [{ varientId: element.variant_id }],
        });
      });
      let totalPrice = cart?.total_price.toString();
      let subTotal = cart?.items_subtotal_price.toString();
      addCreateCartUlai(
        cart.token,
        botDetails?.userId,
        productArray,
        Number(
          `${totalPrice.slice(0, totalPrice.length - 2)}.${totalPrice.slice(
            -2
          )}`
        ),
        Number(
          `${subTotal.slice(0, subTotal.length - 2)}.${subTotal.slice(-2)}`
        )
      );
      setLoading(false);
    }
    else if(event.data.type=="bigComCartUpdate"){
      const{response,productArray,totalPrice,subTotal}=event.data.bigComCartData
      // let tempList = [];
      // let productArray = [];
      // response.lineItems?.physicalItems?.forEach((element) => {
      //   tempList.push(element?.productId);
      //   productArray.push({
      //     productId: element?.productId,
      //     quantity: element?.quantity,
      //     varient: [{ varientId: element?.variantId }],
      //   });
      // });
      // let totalPrice = response?.cartAmount;
      // let subTotal = response?.baseAmount?.toString();

      // let cart = await getBigcommerceCart();
      addCreateCartUlai(
        response?.id,
        botDetails?.userId,
        productArray,
        totalPrice,
        subTotal
      );
      setLoading(false);
    }
   
  
      else if(event.data.type=="suggestion"){
        appstore.getState().setShowSuggestions(true);
      }
    
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  useEffect(()=>{
    if(rufusSend.type==="rufusText"){
      const event = { preventDefault: () => {} };
  sendMessageToBot(event,rufusSend.message)
    }
    else if(rufusSend.type==="rufusTextKnow"){
      const event = { preventDefault: () => {} };
      knowMoreAboutIt(rufusSend.message)
    }
  },[rufusSend])
 

  // console.log(mycart,"=========+> my cAret")


  return (
    initialCallMade && (
      <Box>
        <Box
          className="chatbot-main-container"
          pos={"fixed"} // Adjust position based on mobile or desktop
          bottom={
            isMobile
              ? botDetails.bottomPlacementMobile
              : botDetails.bottomPlacement
          } // Set bottom position for mobile or use botDetails.bottomPlacement
          right={
            isMobile
              ? botDetails.rightPlacementMobile
              : botDetails.rightPlacement
          } // Set right position for mobile or use botDetails.rightPlacement
          zIndex={2147483647}
        >
          <ScaleFade
            initialScale={1}
            in={true}
            exit={false}
            transition={{ exit: { duration: 0.5 }, enter: { duration: 0.5 } }}
          >
            {/* top section */}
            <Box
              className="chat-bot-container"
              openChatBot={openChatBot}
              position={"relative"}
              overflow={"hidden"}

              // display={"flex"}
            >
              <HomeMenu
                conversationStart={conversationStart}
                contactUsMsgSend={contactUsMsgSend}
                botDetails={botDetails}
                currentChatPanelview={currentChatPanelview}
                openCart={openCart}
                openChatBot={openChatBot}
                setTrackOrderSearched={setTrackOrderSearched}
                setIsContactUsMsgSend={setIsContactUsMsgSend}
                setCurrentChatPanelview={setCurrentChatPanelview}
                handleContactUs={handleContactUs}
                handleTrackOrder={handleTrackOrder}
                isColorDark={isColorDark}
                handleQty={handleQty}
                mycart={mycart}
                isAskii={isAskii}
                trackOrderSearched={trackOrderSearched}
                isloading={isloading}
                isConvoHide={isConvoHide}
                clickedKnowMoreAboutit={clickedKnowMoreAboutit}
                sendMessageToBotDirectly={sendMessageToBotDirectly}
                handleStartConversation={handleStartConversation}
                setIsConversationStart={setIsConversationStart}
                error={error}
              />
              <ChatMenu
                botOpen={botOpen}
                openCart={openCart}
                setScrolled={setScrolled}
                conversationStart={conversationStart}
                contactUsMsgSend={contactUsMsgSend}
                botDetails={botDetails}
                currentChatPanelview={currentChatPanelview}
                openChatBot={openChatBot}
                setTrackOrderSearched={setTrackOrderSearched}
                setIsContactUsMsgSend={setIsContactUsMsgSend}
                setCurrentChatPanelview={setCurrentChatPanelview}
                handleContactUs={handleContactUs}
                handleTrackOrder={handleTrackOrder}
                isColorDark={isColorDark}
                handleQty={handleQty}
                mycart={mycart}
                trackOrderSearched={trackOrderSearched}
                isloading={isloading}
                isConvoHide={isConvoHide}
                clickedKnowMoreAboutit={clickedKnowMoreAboutit}
                sendMessageToBotDirectly={sendMessageToBotDirectly}
                handleStartConversation={handleStartConversation}
                setIsConversationStart={setIsConversationStart}
                transformedData={transformedData}
                messagesContainerRef={messagesContainerRef}
                showTyping={showTyping}
                scrolled={scrolled}
                isAskii={isAskii}
                suggestions={suggestions}
                onSuggestionSelected={onSuggestionSelected}
                isAskingRating={isAskingRating}
                showEndConv={showEndConv}
                setAskingRating={setAskingRating}
                sendMessageToBot={sendMessageToBot}
                userMessage={userMessage}
                setUserMessage={setUserMessage}
                setShowPicker={setShowPicker}
                showPicker={showPicker}
                onEmojiClick={onEmojiClick}
                setRating={setRating}
                rating={rating}
                handleSubmitReview={handleSubmitReview}
                error={error}
              />
              {!isAskii&&<PoweredBy currentChatPanelview={currentChatPanelview} />}
            </Box>
      
          </ScaleFade>
        </Box>
      </Box>
    )
  );
}
